var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"my-5",attrs:{"justify-center":""}},[_c('h1',[_vm._v("Site Management System")])]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"href":_vm.url,"color":"green darken-3"}},[_vm._v("\n        Please log in\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af41dc8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 294
// module chunks = 0